import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { CarPic, OwnerPic, StarIcon, EmptyStarIcon, Info } from "../icons";
import { AddVehicleToFavorites } from "../services/btc-api.service";
import { initUserSession } from "../services/auth.service";
import { useMediaQuery } from "react-responsive";

export default function Card({ special, vehicle, isRelated = false }) {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  var imageBasePath =
    window.location.protocol + "//" + window.location.host + "/";

  const addFavorite = async () => {
    if (user && user._id) {
      await AddVehicleToFavorites(user._id, {
        auctionType: vehicle.auctionType,
        vehicleId: vehicle._id,
      });

      await initUserSession();

      // window.location.reload();
    } else {
      navigate("/login");
    }
  };

  const moveToDetailsPage = () => {
    navigate(`/car-details/${vehicle._id}`);
  };

  return (
    <div
      className={`custom-card ${special && "special"}`}
      style={{ cursor: "pointer" }}
    >
      <div className={`special-card-top card-top ${special && "special"}`}>
        {vehicle && (
          <CarPic
            onClickPic={moveToDetailsPage}
            src={`${process.env.REACT_APP_BTC_API_URL}/${vehicle.thumbnail}`}
          />
        )}
        {vehicle.isFavorite}
        {vehicle.isFavorite && <StarIcon className onClickAdd={addFavorite} />}

        {vehicle.isFavorite != true && (
          <EmptyStarIcon onClickAdd={addFavorite} />
        )}
        {vehicle.isSold && (
          <img
            className="owner"
            src={imageBasePath + "sold.png"}
            onClick={moveToDetailsPage}
            alt={"sold.png"}
          />
        )}
        <div className={`damagedUsedContainercard-${isRelated}`} >
          {vehicle?.condition === "DAMAGE" && (
            <button className="damagedcard-2">
              <p
                className="some_thing-2"
              >
                Damaged
              </p>
            </button>
          )}
          {vehicle?.condition === "USED" && (
            <button className="usedcard-2">
              <p
                className="some_thing-2"
              >
                Used
              </p>
            </button>
          )}
        </div>
        {vehicle.isSold != true && <OwnerPic src={"card-pic.png"} onClickTo={moveToDetailsPage} />}
        <div className="stockNoCard">Stock No. {vehicle.auctionNo}</div>{" "}
      </div>
      <div
        onClick={moveToDetailsPage}
        className={`card-body special-card-body ${special && "special"}`}
      >
        {isMobile === false ? (
          <h1>
            {vehicle?.name.length > 12
              ? vehicle?.name.substring(0, 12) + "..."
              : vehicle?.name}
          </h1>
        ) : (
          <h1>
            {vehicle?.name.length > 12
              ? vehicle?.name.substring(0, 12) + "..."
              : vehicle?.name}
          </h1>
        )}

        <div className="price-wrap special-price-wrap">
          <h4>
            {vehicle.discountPrice.toLocaleString(undefined, {
              maximumFractionDigits: 2,
            })}{" "}
            Yen
          </h4>
        </div>
        <div className="price-wrap-2 special-price-wrap-2">
          {vehicle && vehicle.auctionType && (
            <h3>
              {vehicle.auctionType === "SUGGESTIONS"
                ? "Negotiation"
                : vehicle.auctionType.toLowerCase()}{" "}
              :
            </h3>
          )}
        </div>
        <div style={{ display: "flex" }}>
          <b className="locationcard locationcard-special">Location : </b>
          <span className="currentAddressSearch-home currentAddressSearch-home-special">
            {vehicle.currentAddress}
          </span>
          {/* <Info className="infoIconcards special-infoIconcards" /> */}
          <span className="infoQuestion">?</span>
        </div>
      </div>
      {special ? (
        <div className="card-footer special" onClick={moveToDetailsPage}>
          <div className="km">{vehicle.mileage} km</div>
          <div className="km">{vehicle.year}</div>
          <div className="km">{vehicle.displacement} cc</div>
          <div className="km">{vehicle.fuel}</div>
        </div>
      ) : (
        <div className="card-footer" onClick={moveToDetailsPage}>
          <div className="km">{vehicle.mileage} km</div>
          <div className="km">{vehicle.year}</div>
          <div className="km">{vehicle.displacement} cc</div>
          <div className="km">{vehicle.fuel}</div>
        </div>
      )}
    </div>
  );
}
